import React, { useState, useEffect } from "react";
import { FetchWithAuth } from "./utils/FetchWithAuth";
import { useAuthenticated } from "react-admin";
import { Title } from "react-admin";
import PreviewModal from "./PreviewModal";
import MarkdownPopupEditor from "./MarkdownPopupEditor";
import { useNotify } from "react-admin";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { Button } from "@mui/material";
import {Tooltip} from "@mui/material";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import UploadIcon from "@mui/icons-material/Upload";


const API_BASE = process.env.REACT_APP_API_BASE+"/admin";

const Documents = () => {
  useAuthenticated();
  const [path, setPath] = useState("/"); // path sekarang
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null); // untuk upload
  const [previewFile, setPreviewFile] = useState(null);
  const [showEditor, setShowEditor] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);
  const [fileContent, setFileContent] = useState("");

  const openMdEditor = (item) => {
    setCurrentFile(item);
    // di sini kamu bisa load isi file MD dari backend kalau mau
    // contoh: fetch(`/files/${item.name}`).then(res => res.text()).then(setFileContent);

    setFileContent("/documents"+ path + "/" + item.name);
    setShowEditor(true);
  }

  // fungsi simpan file (misalnya update ke backend)
  const  saveMdFile = (newContent) => {
    console.log("Save file:", currentFile.name, newContent);
    // di sini bisa panggil API misal POST ke /update-md-file
    // lalu tutup editor
    setShowEditor(false);
  }

// Ambil isi folder
  const fetchItems = async () => {
     try {
        setLoading(true);

        const res = await FetchWithAuth(
        `${API_BASE}/list.php?path=${encodeURIComponent(path)}`
        );

        // kalau res null berarti sudah di-redirect ke login
        if (!res) return;

 
        if (!res.ok) {
        throw new Error(`Error ${res.status}: ${res.statusText}`);
        }
         
        const data = await res.json();

        data.sort((a, b) => {
        const numA = parseInt(a.name);
        const numB = parseInt(b.name);
        if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
        return a.name.localeCompare(b.name, "id", { numeric: true });
      });
        
        setItems(data);
    } catch (err) {
        console.error("Failed to fetch items:", err);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [path]);

  // Tambah folder baru
  const createFolder = async () => {
    const name = prompt("Nama folder baru:");
    if (!name) return;

    await FetchWithAuth(`${API_BASE}/create.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path, name }),
    });
    fetchItems();
  };

  // Hapus file/folder
  const deleteItem = async (name) => {
    if (!window.confirm(`Hapus "${name}" ?`)) return;

    await FetchWithAuth(`${API_BASE}/delete.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path, name }),
    });
    fetchItems();
  };

  // Rename file/folder
  const renameItem = async (oldName) => {
    const newName = prompt("Nama baru:", oldName);
    if (!newName || newName === oldName) return;

    await FetchWithAuth(`${API_BASE}/rename.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path, old: oldName, new: newName }),
    });
    fetchItems();
  };

  // Masuk ke folder
  const enterFolder = (name) => {
    setPath((prev) => prev.replace(/\/+$/, "") + "/" + name);
  };

  // Naik ke atas
  const goUp = () => {
    if (path === "/") return;
    setPath(path.replace(/\/[^/]+$/, "") || "/");
  };

  // Upload file
  // const uploadFile = async () => {
  //   if (!file) {
  //     alert("Pilih file dulu!");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("path", path);

  //   await FetchWithAuth(`${API_BASE}/upload.php`, {
  //     method: "POST",
  //     body: formData,
  //   });

  //   setFile(null);
  //   document.getElementById("fileInput").value = ""; // reset input
  //   fetchItems();
  // };

  const notify = useNotify();

  const uploadFile = async () => {
    if (!file) {
      notify("Pilih file dulu!", { type: "warning" });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("path", path);

    try {
      const response = await FetchWithAuth(`${API_BASE}/upload.php`, {
        method: "POST",
        body: formData,
      });

      // --- Jika response bukan 2xx, atau error dari server ---
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        notify(err.error || "Upload gagal", { type: "error" });
        return;
      }

      const data = await response.json();

      if (data.error) {
        notify(data.error, { type: "error" });
        return;
      }

      // --- Jika sukses ---
      notify("File berhasil diupload!", { type: "success" });

      setFile(null);
      document.getElementById("fileInput").value = "";
      fetchItems();
    } catch (error) {
      console.error(error);
      notify("Terjadi kesalahan jaringan", { type: "error" });
    }
  };


  

  return (
<div style={{ padding: "1rem" }}>
  <Title title="Documents" />
 
  <p style={{fontSize:12}}>Path: {path}</p>


  {/* PRIMARY BUTTONS: ADDED BACKGROUND & TEXT COLOR */}
  <Tooltip title="Create New Folder">
  <Button
    variant="contained"
    startIcon={<CreateNewFolderIcon />}
    onClick={createFolder}
    disabled={path === "/"}
    sx={{
      backgroundColor: "#007bff",
      color: "#fff",
      textTransform: "none",
      padding: "6px 14px",
      borderRadius: "4px",
      '&:hover': { backgroundColor: "#0069d9" }
    }}
  >
    Folder
  </Button>
</Tooltip>
<Tooltip title="Go Up">
  <Button
    variant="contained"
    startIcon={<ArrowUpwardIcon />}
    onClick={goUp}
    disabled={path === "/"}
    sx={{
      marginLeft: "1rem",
      backgroundColor: "#6c757d",
      color: "#fff",
      textTransform: "none",
      padding: "6px 14px",
      borderRadius: "4px",
      '&:hover': { backgroundColor: "#5a6268" }
    }}
  >
    Up
  </Button>
</Tooltip>


    <text style={{ marginRight: "1rem",marginLeft: "1rem",}}>Upload File</text> 
    <input
      id="fileInput"
      type="file"
      onChange={(e) => setFile(e.target.files[0])}
      disabled={path === "/"}
    />
   <Tooltip title="Upload File">
  <Button
    variant="contained"
    onClick={uploadFile}
    disabled={!file || path === "/"}
    startIcon={<UploadIcon />}
    sx={{
      marginLeft: "0.5rem",
      backgroundColor: "#28a745",
      color: "#fff",
      textTransform: "none",
      padding: "6px 14px",
      borderRadius: "4px",
      '&:hover': { backgroundColor: "#218838" }
    }}
  >
    Upload
  </Button>
</Tooltip>


  {loading ? (
    <p>Loading...</p>
  ) : (
    <ul
      style={{
        marginTop: "1rem",
        listStyleType: "none",
        padding: 0,
        border: "1px solid #ddd",
        borderRadius: "4px",
        backgroundColor: "white",
      }}
    >
      {items.map(function(item, index) {
      const isMd = item.name.endsWith(".md");
      return (
        
        <li
          key={item.id}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0.25rem 0.5rem",
            borderBottom: "1px solid #eee",
            border: "1px solid #dbd7d7ff",
            cursor: "pointer",
            backgroundColor: index % 2 === 0 ?   'transparent' :'#f1f1f1'
   
          }}
          onClick={() =>
            item.type === "folder"
              ? enterFolder(item.name)
              : setPreviewFile(item)
          }
        >
          <span style={{ flexGrow: 1, fontSize:"14px" }}>
            {item.type === "folder" ? (
              <span
                style={{ cursor: "pointer" }}
              
              >
                📁 {item.name}
              </span>
            ) : (
              <span>
                📄 <span style={{ color: "#1f262dff", textDecoration: "underline", cursor: "pointer" }}>
                  {item.name}
                </span>
              </span>
            )}
          </span>

          {/* SECONDARY BUTTONS: ADDED BACKGROUND & TEXT COLOR */}
          <span style={{display: "flex", gap: "5px", marginLeft: "1rem" , marginTop:"0.15em", marginBottom:"0.15em"}}>
            {isMd && (
              <Tooltip title="Edit file Markdown">
              <Button
                variant="contained"
                onClick={(e) => {   
                  e.stopPropagation();
                  openMdEditor(item);}}
                disabled={path === "/"}
                sx={{
                  minWidth: "28px",
                  width: "28px",
                  height: "28px",
                  padding: 0,
                  backgroundColor: "#04b530",
                  color: "#fff",
                  borderRadius: "4px",
                  '&:hover': { backgroundColor: "#039a28" }
                }}
              >
                <EditNoteIcon fontSize="small" />
              </Button>
              </Tooltip>
              // <button
         
            )}
            <Tooltip title="Rename">
            <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  renameItem(item.name);}}
                disabled={path === "/"}
                sx={{
                  minWidth: "28px",
                  width: "28px",
                  height: "28px",
                  padding: 0,
                  backgroundColor: "#ffc107",
                  color: "#333",
                  borderRadius: "4px",
                  '&:hover': { backgroundColor: "#e0a800" }
                }}
              >
                <EditIcon fontSize="small" />
              </Button>
          </Tooltip>
          <Tooltip title="Delete">
           <Button
            variant="contained"
            onClick={(e) => {
               e.stopPropagation();
              deleteItem(item.name);}}
            disabled={path === "/"}
            sx={{
              minWidth: "28px",
              width: "28px",
              height: "28px",
              padding: 0,
              backgroundColor: "#dc3545",
              color: "#fff",
              borderRadius: "4px",
              '&:hover': { backgroundColor: "#bb2d3b" }
            }}
          >
            <DeleteIcon fontSize="small" />
          </Button>
          </Tooltip>
          </span>
        </li>
      );})}
      {items.length > 0 && (
        <style dangerouslySetInnerHTML={{ __html: `
          ul > li:last-child {
            border-bottom: none !important;
          }
        ` }} />
      )}
    </ul>
  )}
   {/* Modal Preview */}
      {previewFile && (
        <PreviewModal
          file={previewFile}
          onClose={() => setPreviewFile(null)}
          path={path}
        />
      )}
      <MarkdownPopupEditor
        isOpen={showEditor}
        initialContent={fileContent}
        onClose={() => setShowEditor(false)}
        onSave={saveMdFile}
        path={path}
      />
      
</div>
  );
};

export default Documents;
